import { useTranslation } from 'react-i18next'
import DashboardTabLayout from '@/components/dashboard/DashboardTabLayout'

export default function HoursHub() {
  const { t } = useTranslation('dashboard')

  return (
    <DashboardTabLayout
      title={t('hubs.hours.title')}
      subtitle={t('hubs.hours.subtitle')}
      tabs={[
        {
          id: 'availability',
          label: t('hubs.hours.tabs.availability'),
          to: '/dashboard/hours/availability',
        },
        {
          id: 'breaks',
          label: t('hubs.hours.tabs.breaks'),
          to: '/dashboard/hours/breaks',
        },
        {
          id: 'peak-pricing',
          label: t('hubs.hours.tabs.peakPricing'),
          to: '/dashboard/hours/peak-pricing',
          requiredFeature: 'pricing.dynamic',
        },
        {
          id: 'locations',
          label: t('hubs.hours.tabs.locations'),
          to: '/dashboard/hours/locations',
        },
      ]}
    />
  )
}
